export default {
  CREATE_CAFE_DISCOUNT_REQUEST_LOADING: 'CREATE_CAFE_DISOCUNT_REQUEST_LOADING',
  CREATE_CAFE_DISCOUNT_REQUEST_SUCCESS: 'CREATE_CAFE_DISOCUNT_REQUEST_SUCCESS',
  CREATE_CAFE_DISCOUNT_REQUEST_FAILED: 'CREATE_CAFE_DISOCUNT_REQUEST_FAILED',
  CREATE_CAFE_DISCOUNT_REQUEST_REJECT: 'CREATE_CAFE_DISOCUNT_REQUEST_REJECT',

  GET_MY_CAFE_DISCOUNTS_LIST_LOADING: 'GET_MY_CAFE_DISCOUNTS_LIST_LOADING',
  GET_MY_CAFE_DISCOUNTS_LIST_SUCCESS: 'GET_MY_CAFE_DISCOUNTS_LIST_SUCCESS',
  GET_MY_CAFE_DISCOUNTS_LIST_FAILED: 'GET_MY_CAFE_DISCOUNTS_LIST_FAILED',
  GET_MY_CAFE_DISCOUNTS_LIST_REJECT: 'GET_MY_CAFE_DISCOUNTS_LIST_REJECT',

  FETCH_ALL_CAFE_DISCOUNT_REQUESTS_LOADING: 'FETCH_ALL_CAFE_DISCOUNT_REQUESTS_LOADING',
  FETCH_ALL_CAFE_DISCOUNT_REQUESTS_SUCCESS: 'FETCH_ALL_CAFE_DISCOUNT_REQUESTS_SUCCESS',
  FETCH_ALL_CAFE_DISCOUNT_REQUESTS_FAILED: 'FETCH_ALL_CAFE_DISCOUNT_REQUESTS_FAILED',
  FETCH_ALL_CAFE_DISCOUNT_REQUESTS_REJECT: 'FETCH_ALL_CAFE_DISCOUNT_REQUESTS_REJECT',

  FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_LOADING: 'FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_LOADING',
  FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS: 'FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS',
  FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_FAILED: 'FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_FAILED',
  FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_REJECT: 'FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_REJECT',

  FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_LOADING: 'FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_LOADING',
  FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_SUCCESS: 'FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_SUCCESS',
  FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_FAILED: 'FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_FAILED',
  FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_REJECT: 'FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_REJECT',

  UPDATE_CAFE_DISCOUNT_REQUEST_LOADING: 'UPDATE_CAFE_DISCOUNT_REQUEST_LOADING',
  UPDATE_CAFE_DISCOUNT_REQUEST_SUCCESS: 'UPDATE_CAFE_DISCOUNT_REQUEST_SUCCESS',
  UPDATE_CAFE_DISCOUNT_REQUEST_FAILED: 'UPDATE_CAFE_DISCOUNT_REQUEST_FAILED',
  UPDATE_CAFE_DISCOUNT_REQUEST_REJECT: 'UPDATE_CAFE_DISCOUNT_REQUEST_REJECT',

  CLEAR_CREATE_CAFE_DISCOUNT_REQUEST_FORM: 'CLEAR_CREATE_CAFE_DISCOUNT_REQUEST_FORM'
};
